import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { PageContainer } from './components/PageContainer';
import { HomePage } from './pages/HomePage';
import { AdminPage } from './pages/AdminPage';
import GaragePage from './pages/GaragePage';
import AddCarPage from './pages/AddCarPage';
import ProfilePage from './pages/ProfilePage';
import FaqPage from './pages/FaqPage';
import SignInPage from './pages/SignInPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

export default function App() {
  return (
    <AppShell>
      <Routes>
        {/* HomePage manages its own width — narrow for the empty-state CTA,
            full-bleed for the map + results in result state. It also handles
            /parking/:parkingId itself: the detail sheet slides in over the
            map/list rather than being a separate full-page route (Q20). */}
        <Route path="/" element={<HomePage />} />
        <Route path="/parking/:parkingId" element={<HomePage />} />
        {/* City landing pages - redirect to search with city coordinates */}
        <Route path="/city/:citySlug" element={<HomePage />} />
        <Route
          path="/garage"
          element={
            <PageContainer width="reading">
              <GaragePage />
            </PageContainer>
          }
        />
        <Route
          path="/garage/add"
          element={
            <PageContainer width="reading">
              <AddCarPage />
            </PageContainer>
          }
        />
        <Route
          path="/profile"
          element={
            <PageContainer width="reading">
              <ProfilePage />
            </PageContainer>
          }
        />
        <Route
          path="/faq"
          element={
            <PageContainer width="reading">
              <FaqPage />
            </PageContainer>
          }
        />
        <Route
          path="/signin"
          element={
            <PageContainer width="reading">
              <SignInPage />
            </PageContainer>
          }
        />
        <Route
          path="/privacy"
          element={
            <PageContainer width="reading">
              <PrivacyPage />
            </PageContainer>
          }
        />
        <Route path="/terms" element={<PageContainer width="reading"><TermsPage /></PageContainer>} />
        {/* Hidden admin dashboard — no UI link, just bookmark /admin */}
        <Route path="/admin" element={<AdminPage />} />
        {/* Legacy /map and /city routes, and anything else unmatched, fall
            through to home. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
